@if (groupData) {
    <div class="drawer-group-multi-row">
        @if (groupData.headerData) {
            <finder-component-header
                [data]="groupData.headerData"
                [hrDecoration]="groupData.hrDecoration"
            ></finder-component-header>
        }
        @for (row of drawerRows; track $index; let rowIndex = $index) {
            <div class="drawer-group-row">
                @for (drawer of row; track drawer.id; let cardIndex = $index) {
                    <finder-campaign-drawer-card
                        [attr.id]="'card-' + drawer.id"
                        [cardData]="drawer"
                        [cardIndex]="getFullCardIndex(rowIndex, cardIndex) + 1"
                        [groupId]="groupData.blockId"
                        [showCaret]="getFullCardIndex(rowIndex, cardIndex) + 1 === selectedCard"
                    ></finder-campaign-drawer-card>
                }
            </div>
        }
        <finder-campaign-drawer-detail
            [groupId]="groupData.blockId"
            [allowReorder]="true"
            [ngStyle]="css"
        ></finder-campaign-drawer-detail>
    </div>
}

